// extracted by mini-css-extract-plugin
export default {"tooltipArrowBorder":"StdTooltip_tooltipArrowBorder__YAWcs","tooltipWrapper":"StdTooltip_tooltipWrapper__W-8Ga"};